import './App.css';
import Header from './GIS-ge/header/header'
import Model1 from './GIS-ge/model1/Model1';
import Footer from './GIS-ge/Footer/Footer';
import Cover from './GIS-ge/cover/cover';
import Stack from './GIS-ge/stack/stack';
import GeApp from './GeApp';
import { BrowserRouter, Routes, Route } from "react-router-dom";


function App() {
  if (window.location.pathname === '/en') {
    return (
      <GeApp />
    )
  } else {
    return (
      <div>
      <Header />
      <Cover />
      <section id="stack">
      <Stack />
      </section>
      <section id="team">
      <Model1 />
      </section>
      <section id="contacts">
      <Footer />
      </section>
      </div>
    )
  }
  // return (
  //   <div className="App">
  //   <BrowserRouter>
  //     <Routes>
  //       <Route path="/en" element={<GeApp />}>
  //         {/* <Route index element={<Home />} />
  //         <Route path="blogs" element={<Blogs />} />
  //         <Route path="contact" element={<Contact />} />
  //         <Route path="*" element={<NoPage />} /> */}
  //       </Route>
  //     </Routes>
  //     <Header />
  //     <Cover />
  //     <section id="stack">
  //     <Stack />
  //     </section>
  //     <section id="team">
  //     <Model1 />
  //     </section>
  //     <section id="contacts">
  //     <Footer />
  //     </section>
  //   </BrowserRouter>
  //   </div>
  // );
}


export default App;
